<template>
  <div>
    <section class="">
			<div class="container">
				<figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
			</div>
		</section>
    <section>
      <div class="container">
        <ol class="breadcrumb hidden-xs">
            <li><a href="/">首頁</a></li>
            <li><a href="/store">聯盟店家</a></li>
            <li class="active">{{rowData.com_name}}</li>
        </ol>
        <h4 class="title">{{rowData.com_name}}</h4>
        <div class="row">
          <div class="col-md-3 col-sm-3 col-xs-12">
            <div class="store_contact">
              <figure class="pic pull-left text-center">
                <img :src="'https://files.i80.com.tw/images/product/'+rowData.com_resize_image" class="img-responsive"/>
              </figure>
              <p lcass="tel">電話：{{rowData.com_phone}}</p>
              <p class="address">地址：{{rowData.county_name}}{{rowData.district_name}}{{rowData.com_address}}</p>
              <p class="website" v-show="rowData.c_website!=''">
                網址：<a :href="rowData.c_website" target="_blink">點我進入網站</a>
              </p>
            </div>
          </div>
          <div class="col-sm-9 col-sm-9 col-xs-12" style="height:300px;overflow:auto;">
            <p class="edit">
              <p v-html="rowData.website_intro"></p>
            </p>
          </div>
        </div>
        <hr>
        <form class="navbar-form navbar-right">
            <select class="form-control" name="category" v-model="categorySelected">
                <option value="">全部</option>
                <option v-for="option in category" v-bind:value="option.id">{{option.name}}</option>
            </select>
            <div class="form-group">
                <input type="text" v-model="keyword" class="form-control" placeholder="關鍵字">
            </div>
            <button type="button" @click="ProductSearch()" class="btn btn-success">查詢</button>
        </form>
        <div class="row clear">

<paginate
  name="products"
  :list="products"
  :per="12"
  tag="div"
  class="paginate-langs"
>
  <div class="col-md-3 col-sm-4 col-xs-6" v-for="item in paginated('products')">
    <div class="product_box">
      <figure class="pic justify">
        <router-link :to="'/store/product/'+item.id+'/'+rowData.m_factoryID + '/'+ userID">
          <img :src="'https://files.i80.com.tw/images/product/'+item.imageM" class="img-responsive"/>
        </router-link>
      </figure>
      <h5 class="title">{{ item.name }}</h5>
      <p class="points" v-if="rowData.point > 0"><span class="glyphicon glyphicon-gift" aria-hidden="true"></span>{{ item.point }}點</p>
      <p class="price" v-if="rowData.price > 0">{{item.price}}</p>
      <button v-if="rowData.balance >= item.price && rowData.com_shopping=='Y'" class="addcart btn btn-default i80_btn" type="button"  @click="ADD_TO_CART(item)">
        <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> 加入購物車
      </button>
    </div>
  </div>
</paginate>
        </div>
<center>
  <nav aria-label="Page navigation example">
  <paginate-links
    for="products"
    :classes="{
      'ul': ['pagination','pagination-sm'],
      'li': 'page-item'
    }"
  ></paginate-links>
  </nav>
</center>
      </div>
    </section>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'StoreView',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      originProduct: Object,
      products: Object,
      rowData: {},
      userID: this.$store.getters.getUserID,
      paginate: ['products'],
      keyword: '',
      category: [],
      categorySelected: 0
    }
  },
  created: function () {
    let id = this.$route.params.id
    let vm = this
    vm.$http.get(this.apiurl + 'api/getCategory/' + id).then(function (res) {
      let category = res.body.data
      category.forEach(function (value, index) {
        value.id = value.products_id
        value.name = value.product_title
      })
      vm.category = category
    }, function () {
    })

    vm.$http.get(this.apiurl + 'api/getProduct/' + id).then(function (res) {
      vm.products = res.body.data.sort(function (a, b) {
        return a.sorting - b.sorting
      })
      vm.originProduct = vm.products
    }, function () {
      // console.log('loading products is failed.')
    })
    let data = this.loadCompany(id)
    this.rowData = data[0]
  },
  computed: {
    ...mapGetters([
      'getCompanies'
    ])
  },
  methods: {
    ...mapActions([
      'ADD_TO_CART'
    ]),
    addToCart (row) {
      window.alert('已加入購物車中')
      this.$store.dispatch('ADD_TO_CART', row)
    },
    loadCompany (id) {
      let companies = JSON.parse(window.localStorage.getItem('companies'))
      // let companies = this.$store.getters.getCompanies
      return companies.filter(function (val) {
        return parseInt(val.comid) === parseInt(id)
      })
    },
    ProductSearch () {
      let keyword = this.keyword
      if (keyword !== '') {
        this.products = this.originProduct
        this.products = this.products.filter(function (value) {
          return value.name.indexOf(keyword) >= 0
        })
      } else {
        // this.productList = this.$store.getters.getProducts
      }
    }
  },
  watch: {
    categorySelected: {
      handler: function (val, oldVal) {
        if (val === '') {
          this.products = this.originProduct
        } else {
          let products = this.originProduct
          this.products = products.filter(function (value) {
            return value.parent_id === val
          })
        }
      }
    }
  },
  metaInfo: {
    title: '愛幫您-聯盟店家',
    meta: [{
      name: '愛幫您-聯盟店家',
      content: '這邊擁有最多元的聯盟店家選擇，且都經過平台層層把關。'
    }],
    link: [{
      rel: 'storeview',
      href: 'https://www.i80.com.tw/storeview'
    }]
  }
}
</script>



// WEBPACK FOOTER //
// StoreView.vue?5f24987b